import { startOfDay, subDays } from 'date-fns';
import { reinterpretUTCAsLocalDate } from 'src/components/common/InsightsDateRangeControl/InsightsDateRangeControl.utils';
import { getDateRangeFilterDetail } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/utils/formatFilterValues';
import { FilterDetail } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';

export const DEFAULT_DATE_RANGE_DAYS = 90;

export interface DefaultDateRange {
  from: Date;
  to: Date;
}

export const getDefaultDateRange = (
  filterDetails: FilterDetail[],
  dataLastUpdated: string | undefined
): DefaultDateRange => {
  const today = startOfDay(new Date());
  const dateRangeFilterDetail = getDateRangeFilterDetail(filterDetails);

  const formattedDataLastUpdated = reinterpretUTCAsLocalDate(dataLastUpdated);
  const fallbackToDate = formattedDataLastUpdated
    ? startOfDay(formattedDataLastUpdated)
    : subDays(today, 1);

  const toDate =
    reinterpretUTCAsLocalDate(dateRangeFilterDetail?.dateRange.endDate) ??
    fallbackToDate;

  const fallbackFromDate = subDays(today, DEFAULT_DATE_RANGE_DAYS);
  const rawFromDate =
    reinterpretUTCAsLocalDate(dateRangeFilterDetail?.dateRange.startDate) ??
    fallbackFromDate;

  const fromDate = rawFromDate > toDate ? toDate : rawFromDate;

  return { from: fromDate, to: toDate };
};
